import axios from "axios";
import * as types from "./mutationTypes";

export const STORAGE_NAME = "t-features-enabled";

export default {
  async loadFeatures({ rootState, commit }) {
    const { organization } = rootState;
    const baseUrl = process.env.FEATURE_TOGGLE_API;
    const token = process.env.FEATURE_TOGGLE_TOKEN;

    if (!organization?.organization?.uuid || !baseUrl || !token) {
      return;
    }

    const queryParams = `?id=${organization.organization.uuid}&token=${token}`;

    try {
      const { data } = (await axios.get(baseUrl + queryParams)) || {};
      const features = data.features || [];
      localStorage.setItem(STORAGE_NAME, features.join());
      commit(types.SET_FEATURES, features);
      // jogar no local storage
    } catch (error) {
      // carregar do local storage e jogar no state
      const features = localStorage.getItem(STORAGE_NAME) || "";
      commit(types.SET_FEATURES, features.split(","));
    }
  },
  clearFeatures({ commit }) {
    commit(types.CLEAR_FEATURES);
  }
};
